<div class="comments-container">
  <div id="comments-list-container">
    <div id="comments">
      <div class="flex-aligner"></div>

      <ng-template
        #commentTemplate
        let-comment="comment"
        let-isParent="isParent"
        let-index="index"
      >
        <div class="comment" [ngClass]="{ reply: !isParent }">
          <div class="commenter-name">{{ comment?.author }}</div>
          <div class="commenter-role">
            <div>
              <i
                class="small circle icon"
                [ngClass]="{
                  preparer: comment?.role === 'Preparer',
                  reviewer: comment?.role === 'Reviewer'
                }"
              ></i>
              {{ comment?.role }}
            </div>
            <div class="comment-date">{{ comment?.date }}</div>
          </div>
          <div class="comment-labels">
            @if (isParent) { @for (field of comment.commentFields; track field)
            {
            <div
              class="field-label ui label"
              [matTooltip]="field.tooltipContent"
              matTooltipPosition="above"
            >
              <span
                (click)="
                  setfocusOnQuestionChildComp(
                    field?.id,
                    'comment',
                    field?.answerId
                  )
                "
              >
                @if (showQuestionId) {
                <span>{{ field?.id }}.</span>
                }
                {{ field?.question }}</span
              >
            </div>
            } }
          </div>

          <div class="comment-text">
            <app-comment
              [comment]="comment"
              [documents]="documents"
              (imgClick)="setModal.emit($event)"
            ></app-comment>
          </div>

          @if (isParent) { @for (reply of comment.comments; track reply) {
          <div>
            <ng-container
              *ngTemplateOutlet="
                commentTemplate;
                context: { comment: reply, isParent: false }
              "
            >
            </ng-container>
          </div>
          } @if (comment.replyTo) {
          <div class="reply-comment">
            <app-attachments
              [(ngModel)]="comment.replyComment"
              (setModal)="setModal.emit($event)"
            ></app-attachments>
            <div style="margin-top: 0.76em">
              <span (click)="cancelReply(comment)" class="cancel-reply">{{
                "taxReturns.cancel" | transloco
              }}</span>
              <div
                (click)="saveCommentReply(comment)"
                class="ui primary background button"
                [ngClass]="{
                  disabled: !comment.replyComment.message,
                  loading: isSavingReply
                }"
              >
                {{ "taxReturns.post" | transloco }}
              </div>
            </div>
          </div>
          } @if (!readonly && !comment.replyTo) {
          <span
            class="reply-btn"
            [class.disabled]="commentFields?.length > 0"
            (click)="commentFields.length === 0 && (comment.replyTo = true)"
            [attr.data-tooltip]="
              commentFields.length > 0
                ? ('taxReturns.save-inputs-first' | transloco)
                : null
            "
            [attr.data-position]="'top right'"
            [attr.data-variation]="'black'"
            >{{ "taxReturns.reply" | transloco }}</span
          >
          } }
        </div>
      </ng-template>

      @for (commentItem of commentsFiltered|orderBy:['dateMoment']:['asc'];
      track commentItem; let index = $index) {
      <ng-container
        *ngTemplateOutlet="
          commentTemplate;
          context: { comment: commentItem, isParent: true, index: index }
        "
      >
      </ng-container>
      }
    </div>
  </div>

  <div id="comment-textbox-container">
    @if (commentFields?.length > 0) {
    <div id="edited-fields">
      <div class="label">{{ "taxReturns.edited-fields" | transloco }}</div>
      <div class="line"></div>
    </div>
    }

    <div id="edit-fields-container">
      @for (field of commentFields; track field) {
      <div class="ui label">
        @if (showQuestionId) {
        <span>{{ field?.id }}.</span>
        } {{ field?.question }}
        @if (isSmartForm) {
        <span
          >@if (field?.rowIndex != null) {
          <span>
            {{ "taxReturns.row" | transloco }} {{ field?.rowIndex + 1 }}</span
          >
          }</span
        >
        } @if (!isSmartForm) {
        <span
          >({{ field?.groupName }}@if (field?.groupName && field?.subGroupName)
          {
          <span> - </span>
          }{{ field?.subGroupName }}@if (field?.rowIndex != null) {
          <span
            >{{ "taxReturns.row" | transloco }} {{ field?.rowIndex + 1 }}</span
          >
          })</span
        >
        } @if (!field?.answerChanged) {
        <i (click)="deleteCommentField.emit(field)" class="close icon"></i>
        }
      </div>
      }
    </div>

    @if (pastedDocMetadatas?.length > 0) {
    <div id="doc-links">
      <div class="label">{{ "taxReturns.document-links" | transloco }}</div>
      <div class="line"></div>
    </div>
    }

    <div id="doc-links-container">
      @for (docMetadata of pastedDocMetadatas; track docMetadata) {
      <a [href]="docMetadata.url" target="_blank" class="ui label">
        {{ docMetadata.filename || docMetadata.url }}
      </a>
      }
    </div>

    <app-attachments
      [formControl]="comment"
      [placeholder]="
        commentFields.length === 0
          ? 'Click a question or change an answer to make a comment'
          : 'Type your comment here...'
      "
      [disableComponent]="commentFields?.length === 0 ? true : null"
      (setModal)="setModal.emit($event)"
    ></app-attachments>

    <div class="doc-links"></div>

    <div
      (click)="saveComment()"
      id="save-comment"
      class="ui primary background button"
      [ngClass]="{ disabled: !comment.value.message, loading: isSaving }"
    >
      {{ "taxReturns.save-and-comment" | transloco }}
    </div>
  </div>
</div>
